module.exports = __webpack_public_path__ + "img/icon.f76a5880.png";